<template>
  <div class="top-contianer">
    <div class="academy-container">
      <div class="main_header">
        <div id="va-logo" class="va-logo">
          <div class="fadingEffect"></div>
          <img class="va-img" src="../../public/img/logos/va.png" />
        </div>
      </div>
      <GearsSep />
      <br />
      <br />
      <br />
      <br />
      <div class="image-zoom-container">
        <br />
        <h2 class="back-text">Our play yard</h2>

        <h3 id="academy-competitions" style="color: #00264a; font-weight: bold;">Competitions</h3>

        <div style="width: 150px" class="breaker"></div>
        <h5 class="notes">Click on the competition to know more and apply</h5>

        <div>
          <div
            v-for="competition in competitions"
            :key="competition.id"
            :id="'competition'+competition.id"
            class="zoom-container"
          >
            <a @click="scrollToCompetitionContent()" v-b-toggle="'collapse-' + competition.id">
              <span class="zoom-caption">
                <h3>{{competition.name}}</h3>
              </span>
              <b-img-lazy class="section-img" :src="competition.logoSrc"></b-img-lazy>
            </a>
          </div>
        </div>
        <b-collapse
          v-for="competition in competitions"
          :key="competition.id"
          accordion="my-accordion"
          :id=" 'collapse-' + competition.id"
          class="mt-2"
        >
          <br />
          <br />

          <div class="competition-content">
            <button
              v-b-toggle="'collapse-' + competition.id"
              type="button"
              class="close"
              aria-label="Close"
            >
              <span class="margin: 20px;" aria-hidden="true">&times;</span>
            </button>
            <div :id="'bigLogo' + competition.id" class="competition-big-logo-container">
              <b-img-lazy class="competition-big-logo" :src="competition.bigLogoSrc"></b-img-lazy>
            </div>
            <br />
            <br />
            <b-container>
              <b-row class="competitions-row">
                <b-col :id="'courses-col-' + competition.id">
                  <b-button
                    size="lg"
                    variant="outline-primary"
                    v-b-toggle="'courses-collapse-' + competition.id"
                    @click="scrollDownLittle()"
                    :disabled="!competition.hasLearningTrack"
                  >Learning track</b-button>
                  <b-tooltip
                    v-if="!competition.hasLearningTrack"
                    :target="'courses-col-' + competition.id"
                  >Same as MATE (it's a follow-up competition)</b-tooltip>
                </b-col>
                <b-col>
                  <b-button
                    :id="'applyNow' + competition.id"
                    class="apply-btn"
                    size="lg"
                    v-b-modal=" 'applyNow' + competition.id"
                    variant="success"
                    :disabled="!competition.applyNow"
                  >Apply Here Now</b-button>
                </b-col>
                <b-col>
                  <b-button
                    size="lg"
                    variant="outline-primary"
                    v-b-toggle="'competition-about-collapse-' + competition.id"
                    @click="scrollDownLittle()"
                    id="competitions-third-button"
                  >About Competition</b-button>
                </b-col>
              </b-row>
            </b-container>
            <b-modal
              :id=" 'applyNow' + competition.id"
              size="lg"
              :title=" 'Apply to ' + competition.name"
            >Hello Large 2!</b-modal>
            <br />
            <b-collapse
              :id=" 'courses-collapse-' + competition.id"
              my-accordion="my-accordion2"
              class="mt-2"
            >
              <section class="timeline">
                <div class="container">
                  <div v-for="course in competition.courses" :key="course.id" class="timeline-item">
                    <div class="timeline-img"></div>
                    <div :class="course.fade" class="timeline-content timeline-card">
                      <div class="timeline-img-header" :style="course.img">
                        <!--<img class="timeline-img-header" :src="course.img" />-->
                        <h2>{{course.name}}</h2>
                      </div>
                      <div class="date">{{course.duration}}</div>
                      <a class="bnt-more" v-b-toggle="course.id" href="javascript:void(0)">Headlines</a>
                      <b-collapse :id="course.id" class="mt-2">
                        <p class="vep_content"></p>
                        <ul style="text-align:left; font-size: 18px;">
                          <li v-for="headline in course.content" :key="headline">
                            {{headline}}
                            <ul v-if="headline === 'Arduino'">
                              <li v-for="sub in course.subContent" :key="sub">{{sub}}</li>
                            </ul>
                          </li>
                        </ul>
                      </b-collapse>
                      <br />
                    </div>
                  </div>
                </div>
                <div class="timeline-end-img"></div>
              </section>
              <b-button
                variant="outline-primary"
                v-b-toggle="'courses-collapse-' + competition.id"
                :href="'#bigLogo' + competition.id"
                style="margin-bottom: 50px;"
              >Hide learning track</b-button>
            </b-collapse>
            <b-collapse
              :id=" 'competition-about-collapse-' + competition.id"
              my-accordion="my-accordion2"
              class="mt-2"
            >
              <div>
                <b-jumbotron>
                  <template v-slot:header>{{competition.name}}</template>
                  <template v-slot:lead>{{competition.fullName}}</template>
                  <hr class="my-4" />
                  <p>{{competition.about.info}}</p>
                  <hr class="my-4" />
                  <b-container>
                    <b-row>
                      <b-col>
                        <div>
                          <b-card class="list-header" header="Competition Phases">
                            <b-list-group>
                              <b-list-group-item
                                v-for="phase in competition.about.phases"
                                :key="phase"
                                variant="outline-primary"
                                href="#"
                              >{{phase}}</b-list-group-item>
                            </b-list-group>
                            <p class="card-text mt-2"></p>
                          </b-card>
                        </div>
                      </b-col>
                      <b-col md="auto">
                        <div>
                          <b-card class="list-header" header="Competition Dates">
                            <b-list-group>
                              <b-list-group-item
                                v-for="date in competition.about.dates"
                                :key="date"
                                variant="outline-primary"
                                href="#"
                              >{{date}}</b-list-group-item>
                            </b-list-group>
                            <p class="card-text mt-2"></p>
                          </b-card>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="list-items">
                          <b-card class="list-header" header="Age Qualifications">
                            <b-list-group>
                              <b-list-group-item
                                v-for="age in competition.about.age"
                                :key="age"
                                variant="outline-primary"
                                href="#"
                              >{{age}}</b-list-group-item>
                            </b-list-group>
                            <p class="card-text mt-2"></p>
                          </b-card>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                  <br />
                  <hr class="my-4" />
                  <br />
                  <div v-if="competition.about.hasVideo" class="container-iframe">
                    <hr class="my-4" />
                    <iframe
                      class="responsive-iframe"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                      :src="competition.about.videoLink"
                    ></iframe>
                  </div>
                  <hr />
                  <b-button
                    :href="competition.about.organisationLink"
                    variant="outline-primary"
                    target="_blank"
                  >Visit organization website</b-button>
                </b-jumbotron>
              </div>
              <b-button
                variant="outline-primary"
                v-b-toggle="'competition-about-collapse-' + competition.id"
                :href="'#bigLogo' + competition.id"
                style="margin-bottom: 30px;"
              >Hide About</b-button>
            </b-collapse>
          </div>
        </b-collapse>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div class="image-zoom-container">
        <br />
        <h2 class="back-text">Our Propagation</h2>

        <h3 style="color: #00264a; font-weight: bold;">Regions</h3>
        <div style="width: 150px" class="breaker"></div>
        <h5 class="notes">Click on the region to know more</h5>

        <div>
          <div
            v-for="region in regions"
            :key="region.id"
            :id="'region'+region.id"
            class="zoom-container"
          >
            <a @click="scrollToRegionContent()" v-b-toggle="'region-collapse-' + region.id">
              <span class="zoom-caption">
                <h3>{{region.name}}</h3>
              </span>
              <b-img-lazy class="section-img" :src="region.flagSrc"></b-img-lazy>
            </a>
          </div>
        </div>
        <b-collapse
          v-for="region in regions"
          :key="region.id"
          accordion="my-accordion"
          :id=" 'region-collapse-' + region.id"
          class="mt-2"
        >
          <br />
          <br />
          <div class="competition-content">
            <button
              v-b-toggle="'region-collapse-' + region.id"
              type="button"
              class="close"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <b-container>
              <b-row>
                <b-col class="competition-big-logo-container">
                  <div>
                    <b-img-lazy class="competition-big-logo" :src="region.bigFlagSrc"></b-img-lazy>
                  </div>
                </b-col>
                <b-col class="region-header" cols="7">
                  <h2>
                    Vortex in
                    <span style="color:red;">{{region.fullName}}</span>
                  </h2>
                </b-col>
                <b-col class="competition-big-logo-container">
                  <div>
                    <b-img-lazy class="competition-big-logo" :src="region.bigFlagSrc"></b-img-lazy>
                  </div>
                </b-col>
              </b-row>
            </b-container>
            <br />
            <br />
            <b-container style="margin-bottom: 50px;">
              <b-row class="competitions-row">
                <b-col :id="'region-work-cont-' + region.id">
                  <b-button
                    size="lg"
                    variant="outline-primary"
                    v-b-toggle="'region-work-collapse-' + region.id"
                    @click="scrollDownLittle()"
                    disabled
                  >Work, Deals & Partners</b-button>
                  <b-tooltip :target="'region-work-cont-' + region.id">Will be updated soon!</b-tooltip>
                </b-col>
                <b-col :id="'region-teams-cont-' + region.id">
                  <b-button
                    size="lg"
                    variant="outline-primary"
                    v-b-toggle="'region-teams-collapse-' + region.id"
                    @click="scrollDownToTeam(region.id)"
                  >Teams & Rovs in {{region.name}}</b-button>
                </b-col>
                <b-col :id="'region-about-cont-' + region.id">
                  <b-button
                    size="lg"
                    variant="outline-primary"
                    v-b-toggle="'region-about-collapse-' + region.id"
                    id="awards-third-button"
                    @click="scrollDownLittle()"
                    disabled
                  >Moments and Insights in {{region.name}}</b-button>
                  <b-tooltip :target="'region-about-cont-' + region.id">Will be updated soon!</b-tooltip>
                </b-col>
              </b-row>
            </b-container>
            <b-collapse :id="'region-teams-collapse-' + region.id">
              <div :id="'teams-region' + region.id" style="width: 60%; margin: auto;">
                <h1 style="color: #00264a;">know the powerfull Vortex Teams in {{region.name}}</h1>
                <br />
                <br />
              </div>
              <b-container class="bv-example-row mb-3">
                <b-row :cols="numOfCols">
                  <b-col style="margin-bottom: 150px;" v-for="team in region.teams" :key="team.id">
                    <b-card no-body class="team-card">
                      <b-img-lazy
                        :id="'team' + team.id + '-region' + region.id"
                        v-b-modal="'big-image-team-' + team.id + '-region-' + region.id"
                        class="card-img-top"
                        :src="team.teamImageSrc"
                      ></b-img-lazy>
                      <b-modal
                        :title="team.name + ' Pictures'"
                        size="xl"
                        centered
                        ok-only
                        :id="'big-image-team-' + team.id + '-region-' + region.id"
                      >
                        <b-img-lazy style="width : 100%; margin:auto;" :src="team.teamImageSrc"></b-img-lazy>
                      </b-modal>
                      <b-card-header>
                        <h4 class="mb-0">{{team.name}}</h4>
                      </b-card-header>
                      <b-card-sub-title
                        style="padding-top: 30px; text-align: center; width: 80%; margin: auto;"
                        class="mb-2"
                      >
                        The team was participating in the
                        <b>{{team.class}}</b> class, and was mentored by Eng.
                        <b>{{team.mentor}}</b> from Vortex Academy.
                      </b-card-sub-title>
                      <hr />
                      <b-card-body>
                        <b-button
                          size="lg"
                          variant="outline-secondary"
                          style="width: 100%;"
                          v-b-toggle="'toggle-insights-' + team.id + '-region-' + region.id"
                        >{{team.name}} Insights</b-button>
                        <b-collapse :id="'toggle-insights-' + team.id + '-region-' + region.id">
                          <b-alert
                            v-if="!team.insights.length"
                            show
                            variant="warning"
                            style="margin-top: 30px;"
                          >No insights available</b-alert>
                          <div>
                            <b-table stacked striped hover :items="team.insights"></b-table>
                          </div>
                        </b-collapse>
                        <b-button
                          size="lg"
                          variant="outline-secondary"
                          style="width: 100%; margin-top: 10px;"
                          :id="'button-team' + team.id+'-region'+ region.id"
                          v-b-toggle="'toggle-rov-' + team.id + '-region-' + region.id"
                        >{{team.name}} ROV</b-button>
                      </b-card-body>

                      <b-collapse :id="'toggle-rov-' + team.id + '-region-' + region.id">
                        <b-card-body style="font-weights: bold; font-size: 140%;">{{team.rovName}}</b-card-body>
                        <b-card-img-lazy
                          v-b-modal="'rov-image-team-' + team.id + '-region-' + region.id"
                          :src="team.rovImageSrc"
                          alt="No current Image Available"
                          bottom
                          class="rov-image"
                        ></b-card-img-lazy>
                        <b-modal
                          :title="team.name + ' ROV (' + team.rovName + ')'"
                          size="lg"
                          centered
                          ok-only
                          :id="'rov-image-team-' + team.id + '-region-' + region.id"
                        >
                          <b-img-lazy style="width : 100%; margin:auto;" :src="team.rovImageSrc"></b-img-lazy>
                        </b-modal>
                      </b-collapse>
                    </b-card>
                  </b-col>
                </b-row>
              </b-container>
            </b-collapse>
          </div>
        </b-collapse>
      </div>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import GearsSep from "./../components/GearsSep.vue";

export default {
  components: {
    GearsSep
  },
  methods: {
    part1() {
      return "linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('";
    },
    part2() {
      return "')  center center no-repeat;";
    },
    scrollDownLittle() {
      window.scroll(0, window.scrollY + 80);
    },
    scrollDownToTeam(regionId) {
      setTimeout(
        () =>
          document
            .getElementById("teams-region" + regionId)
            .scrollIntoView({ behavior: "smooth" }),
        400
      );
    },
    scrollToCompetitionContent() {
      setTimeout(
        () =>
          document
            .getElementById("competition4")
            .scrollIntoView({ behavior: "smooth" }),
        300
      );
    },
    scrollToRegionContent() {
      setTimeout(
        () =>
          document
            .getElementById("region4")
            .scrollIntoView({ behavior: "smooth" }),
        300
      );
    },
    resetNumOfCols() {
      this.numOfCols = Math.ceil(window.innerWidth / 700);
    },
    showError(regionId, teamId) {
      console.log(regionId, teamId);
      if (regionId === 1 && teamId === 7) {
        console.log(
          this.regions[regionId - 1].teams[teamId].insights.length === 0
        );
      }
      if (
        !this.regions[regionId - 1].teams ||
        !this.regions[regionId - 1].teams[teamId] ||
        this.regions[regionId - 1].teams[teamId].insights.length === 0
      )
        return true;
      else return false;
    }
  },
  created() {
    window.addEventListener("resize", this.resetNumOfCols);
  },
  destroyed() {
    window.removeEventListener("resize", this.resetNumOfCols);
  },
  mounted() {
    var tabs = document.getElementById("right_nav").querySelectorAll("a");
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.color = "#00264a";
    }
    document
      .getElementById("vortexNameImage")
      .setAttribute("src", "img/logos/vortex_name.png");
    this.resetNumOfCols();
    $(function() {
      window.sr = ScrollReveal();
      if ($(window).width() < 768) {
        if ($(".timeline-content").hasClass("js--fadeInLeft")) {
          $(".timeline-content")
            .removeClass("js--fadeInLeft")
            .addClass("js--fadeInRight");
        }

        sr.reveal(".js--fadeInRight", {
          origin: "right",
          distance: "300px",
          easing: "ease-in-out",
          duration: 800
        });
      } else {
        sr.reveal(".js--fadeInLeft", {
          origin: "left",
          distance: "300px",
          easing: "ease-in-out",
          duration: 800
        });

        sr.reveal(".js--fadeInRight", {
          origin: "right",
          distance: "300px",
          easing: "ease-in-out",
          duration: 800
        });
      }

      sr.reveal(".js--fadeInLeft", {
        origin: "left",
        distance: "300px",
        easing: "ease-in-out",
        duration: 800
      });

      sr.reveal(".js--fadeInRight", {
        origin: "right",
        distance: "300px",
        easing: "ease-in-out",
        duration: 800
      });
    });
  },
  data() {
    return {
      numOfCols: 3,
      regions: [
        {
          id: 1,
          name: "Egypt",
          fullName: "Egypt",
          flagSrc: "img/logos/regions/egypt.png",
          bigFlagSrc: "img/logos/egypt_big.png",
          teams: [
            {
              id: 0,
              name: "Vortex",
              class: "Explorers",
              mentor: "Abdelrahman Abuklila",
              teamImageSrc: "img/teams/vortex.jpg",
              insights: [
                {
                  competition: "Mate Local",
                  date: "1/3/2017",
                  position: "First",
                  awards: " - "
                },
                {
                  competition: "Mate Regional",
                  date: "11/4/2017",
                  position: "First",
                  awards: "Best team Organization"
                },
                {
                  competition: "Mate International",
                  date: "21/6/2018",
                  position: "Third",
                  awards: "Best team Organization"
                },
                {
                  competition: "UMVC",
                  date: "1/8/2018",
                  position: "First",
                  awards: " - "
                }
              ],
              rovImageSrc: "img/rovs/vray.jpg",
              rovName: "V-Ray"
            },
            {
              id: 1,
              name: "Vortex Titans",
              class: "Explorers",
              mentor: "Abdelrahman Hussein",
              teamImageSrc: "img/teams/titans.jpg",
              insights: [
                {
                  competition: "Mate Local",
                  date: "1/3/2018",
                  position: "Fourth",
                  awards: "Best Team Spirit"
                },
                {
                  competition: "Mate Regional",
                  date: "11/4/2018",
                  position: "First",
                  awards: "Best Pilot"
                },
                {
                  competition: "Mate International",
                  date: "21/6/2018",
                  position: "First",
                  awards: " - "
                },
                {
                  competition: "UMVC",
                  date: "1/8/2018",
                  position: "First",
                  awards: " - "
                }
              ],
              rovImageSrc: "img/rovs/sturgeon.jpg",
              rovName: "Sturgeon"
            },
            {
              id: 2,
              name: "Vortex Jr",
              class: "Explorers",
              mentor: "Abdelrahman Hussein",
              teamImageSrc: "img/teams/jr.jpg",
              insights: [
                {
                  competition: "Mate Local",
                  date: "1/3/2018",
                  position: "Fifth",
                  awards: " - "
                },
                {
                  competition: "Mate Regional",
                  date: "11/4/2018",
                  position: "Sixth",
                  awards: " - "
                },
                {
                  competition: "UMVC",
                  date: "1/8/2018",
                  position: "Second",
                  awards: " - "
                }
              ],
              rovImageSrc: "img/rovs/kraken.jpg",
              rovName: "Kraken"
            },
            {
              id: 3,
              name: "Vortex Troopers",
              class: "Explorers",
              mentor: "Abdelrahman Desouki",
              teamImageSrc: "img/teams/troopers.jpg",
              insights: [
                {
                  competition: "MATE Local",
                  date: "11/2/2019",
                  position: "Fifth",
                  awards: " - "
                },
                {
                  competition: "MATE Regional",
                  date: "11/4/2019",
                  position: "Sixth",
                  awards: " - "
                }
              ],
              rovImageSrc: "img/rovs/comodo.jpeg",
              rovName: "Comodo"
            },
            {
              id: 4,
              name: "Vortex Raiders",
              mentor: "Abdelrahman Desouki",
              class: "Explorers",
              teamImageSrc: "img/teams/raiders.jpg",
              insights: [
                {
                  competition: "MATE Local",
                  date: "11/2/2019",
                  position: "Fourth",
                  awards: " - "
                },
                {
                  competition: "MATE Regional",
                  date: "11/4/2019",
                  position: "Fifth",
                  awards: " - "
                },
                {
                  competition: "UMVC",
                  date: "1/8/2019",
                  position: "Third",
                  awards: " - "
                }
              ],
              rovImageSrc: "",
              rovName: ""
            },
            {
              id: 5,
              name: "Vortex Starks",
              class: "Explorers",
              mentor: "Mohamed AbuKlila",
              teamImageSrc: "img/teams/starks.jpg",
              insights: [
                {
                  competition: "MATE Local",
                  date: "1/2/2020",
                  position: "Fourth",
                  awards: " - "
                }
              ],
              rovImageSrc: "img/rovs/exodia.jpg",
              rovName: "Exodia"
            },
            {
              id: 6,
              name: "Atlantic Explorers",
              class: "Explorers",
              mentor: "Karim ElSayed",
              teamImageSrc: "img/teams/notyet.png",
              insights: [],
              rovImageSrc: "img/rovs/kimo.jpg",
              rovName: "Kimo"
            },
            {
              id: 7,
              name: "ROVolutuion",
              class: "Explorers",
              mentor: "Mahmoud Saeed",
              teamImageSrc: "img/teams/rovolution.jpg",
              insights: [],
              rovImageSrc: "img/rovs/zote.jpg",
              rovName: "Zote"
            },
            {
              id: 8,
              name: "V-Brainnovates",
              class: "Rangers",
              mentor: "Islam Gamal",
              teamImageSrc: "img/teams/brainnovates.jpg",
              insights: [
                {
                  competition: "MATE Regional",
                  date: "11/4/2019",
                  position: "Second",
                  awards: " - "
                },
                {
                  competition: "MATE International",
                  date: "21/6/2019",
                  position: "Ninth",
                  awards: " - "
                }
              ],
              rovImageSrc: "img/rovs/octopus.jpg",
              rovName: "Octopus"
            },
            {
              id: 9,
              name: "Vortex Immortals",
              class: "Rangers",
              mentor: "Abdelaziz Youssry",
              teamImageSrc: "img/teams/immortals.jpg",
              insights: [],
              rovImageSrc: "img/rovs/blue_marlin.jpg",
              rovName: "Blue Marlin"
            },
            {
              id: 10,
              name: "Luminous",
              class: "Explorers",
              mentor: "Mohamed Gamal",
              teamImageSrc: "img/teams/lumious.jpg",
              insights: [],
              rovImageSrc: "img/rovs/coaster.png",
              rovName: ""
            },
            {
              id: 11,
              name: "STEM-kids",
              class: "Scouts",
              mentor: "Amr Essam",
              teamImageSrc: "img/teams/stemkids.png",
              insights: [],
              rovImageSrc: "img/rovs/ladybug.jpg",
              rovName: "Lady Bug"
            },
            {
              id: 12,
              name: "Creative Kids",
              class: "Scounts",
              mentor: "Ibrahim Youssry",
              teamImageSrc: "img/teams/creative_kids.png",
              insights: [],
              rovImageSrc: "img/rovs/redpiranha.jpg",
              rovName: "Red Piranha"
            }
          ]
        },
        {
          id: 2,
          name: "UAE",
          fullName: "The United Arabic Emirates",
          flagSrc: "img/logos/regions/uae.png",
          bigFlagSrc: "img/logos/uae_big.png",
          teams: [
            {
              id: 0,
              name: "Innovation Touch",
              class: "Rangers",
              mentor: "Mohamed Wally",
              teamImageSrc: "img/teams/innovation_touch.jpg",
              insights: [
                {
                  competition: "MATE Arabs Regional",
                  date: "11/4/2019",
                  position: "First",
                  awards: " - "
                },
                {
                  competition: "MATE International",
                  date: "21/6/2019",
                  position: "27th",
                  awards: " - "
                }
              ],
              rovImageSrc: "img/rovs/uae_rov.jpeg",
              rovName: "Innova"
            }
          ]
        },
        {
          id: 3,
          name: "Jordan",
          fullName: "Jordan",
          flagSrc: "img/logos/regions/jordan.png",
          bigFlagSrc: "img/logos/jordan_big.png",
          teams: [
            {
              id: 0,
              name: "Blue Sharx",
              class: "Explorers",
              mentor: "Islam Gamal",
              teamImageSrc: "img/teams/blue_sharx.jpg",
              insights: [],
              rovImageSrc: "img/rovs/marvel.jpg",
              rovName: "Marvel"
            }
          ]
        },
        {
          id: 4,
          name: "USA",
          fullName: "The United States of America",
          flagSrc: "img/logos/regions/usa.png",
          bigFlagSrc: "img/logos/usa_big.png",
          teams: []
        }
      ],
      competitions: [
        {
          id: 1,
          name: "ROBO-SUB",
          fullName: "Autonomous Underwater Vehicle (AUV) competition",
          logoSrc: "img/logos/robosub.png",
          bigLogoSrc: "img/logos/robosub_big.png",
          applyNow: 0,
          about: {
            info:
              "RoboSub is an international student competition. Student teams from around the world design and build robotic submarines, otherwise known as Autonomous Underwater Vehicles (AUV). The behaviors demonstrated by these experimental AUVs mimic those of real-world systems, currently deployed around the world for underwater exploration, seafloor mapping, and sonar localization, amongst many others.",
            age: ["Graduates / Undergraduates (Age: +18)"],
            phases: ["International in SanDiego, USA"],
            dates: ["September"],
            organisationLink: "https://robosub.org/",
            hasVideo: 1,
            videoLink: "https://www.youtube.com/embed/08tTwMYFIqA?autoplay=0"
          },
          courses: [
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/computer_vision.jpg" +
                this.part2(),
              name: "Computer Vision",
              content: [
                "Image Processing Intro",
                "Basic Image Processing",
                "Geometric Transformations",
                "Thresholding",
                "Smoothing Images",
                "Contours",
                "Histograms",
                "Template Matching"
              ],
              duration: "3 Hours",
              id: "course1",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/advanced_embedded.jpg" +
                this.part2(),
              name: "Advanced Embedded Systems",
              content: [
                "Embedded Systems Concepts",
                "Design Steps",
                "Layered Architecture",
                "Modularity and Components design",
                "Compilation Process",
                "Memory types and sections",
                "Intro to RTOS",
                "Interprets"
              ],
              duration: "3 Hours",
              id: "course2",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/ros.jpg" +
                this.part2(),
              name: "Intro to ROS 2",
              content: [
                "ROS2 installation and configuration",
                "Understanding ROS2 nodes, topics and services.",
                "Understanding ROS2 parameters and actions.",
                "Understanding rqt_console",
                "Working with launch files",
                "Creating workspace and packages",
                "Writing publisher and subscriber in C++ & Python",
                "Writing Service and Client in C++ & Python",
                "Creating custom ROS2 msg and srv file",
                "Expanding on ROS2 interfaces",
                "Using parameters in a class",
                "Getting Started with ros2doctor"
              ],
              duration: "3 Hours",
              id: "course3",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/neural_networks.jpg" +
                this.part2(),
              name: "Intro to Neural Networks",
              content: [
                "How Human Brain works",
                "Neural Network Structure",
                "Activation Functions",
                "Loss Functions and Optimizers",
                "Back Propagation",
                "Universal Approximation Theory",
                "Learning types",
                "Deep Neural Networks",
                "Handling input Images",
                "Convolutional Neural Networks"
              ],
              duration: "3 Hours",
              id: "course4",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/wired_comm.jpg" +
                this.part2(),
              name: "Wired Communication",
              content: [
                "Intro to Serial and Parallel communication",
                "UART, SPI, I2C, CAN, ETHERNET, etc..",
                "Cracking the codes for these protocols using MCs"
              ],
              duration: "3 Hours",
              id: "course5",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/wireless_comm.jpg" +
                this.part2(),
              name: "Wireless Communication",
              content: [
                "Intro to digital communication",
                "some digital modulation techniques.",
                "Intro to DSP concepts",
                "Some MATLAB examples about FFT and DFT",
                "Acoustic communication tips"
              ],
              duration: "3 Hours",
              id: "course6",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/pcb.jpg" +
                this.part2(),
              name: "PCB",
              content: [
                "Breif intro to Eagle Software",
                "How to design Double layer PCB",
                "Limitation on Design and size of PCB.",
                "Plug and play concept.",
                "Hints for manufacturing.",
                "Draw a solid design for each PCB With Mech. Team"
              ],
              duration: "3 Hours",
              id: "course7",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/power.jpg" +
                this.part2(),
              name: "Power Conversions & Calculations",
              content: [
                "Briefly intro for Electrical system in ROV.",
                "Difference between ROV and AUV",
                "Component selection and load sheet.",
                "DC-DC Convertors",
                "Battery calculations and Recharging.",
                "Power sources and backup system."
              ],
              duration: "3 Hours",
              id: "course8",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/machining.jpg" +
                this.part2(),
              name: "Machining and Manufacturing",
              content: [
                "General Machine Concepts",
                "CNC Machines",
                "Number of Aexs",
                "Available Machining Methods",
                "Laser cutting",
                "Routers",
                "3D printing",
                "Lathing & Milling",
                "Exporting extensions for Machining",
                "Criteria for choosing a machining method"
              ],
              duration: "3 Hours",
              id: "course9",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/sealing.jpg" +
                this.part2(),
              name: "Sealing Techniques",
              content: [
                "Sealing Basics",
                "Codes / Standards",
                "Static VS Dynamic Sealing",
                "Cables, Techniques, O-Rings for Static Seal.",
                "Testing",
                "Safety Procedures",
                "Drawing Sheets",
                "Workshop: Full design of enclosure"
              ],
              duration: "3 Hours",
              id: "course10",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/propulsion.jpg" +
                this.part2(),
              name: "Propulsion",
              content: [
                "Intro to propulsion",
                "Forces on propeller",
                "Selection and Testing",
                "Effects of thrust on Stability",
                "AUV Motion and configs",
                "Dynamic Testing",
                "General thrust safety"
              ],
              duration: "3 Hours",
              id: "course11",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/auv_mech_design.jpg" +
                this.part2(),
              name: "Mechanical Design Considerations",
              content: [
                "AUV Main Components",
                "Design Concepts and Constrains",
                "Forces Acting on AUV",
                "Basics of Buoyancy",
                "Centers of Buoyancy and mass",
                "Workshop: Center of Buoyancy and Stability (SolidWorks)",
                "Intro to manipulators"
              ],
              duration: "3 Hours",
              id: "course12",
              fade: "js--fadeInRight"
            }
          ],
          hasLearningTrack: 1
        },
        {
          id: 2,
          name: "SEA-PERCH",
          fullName: "Innovative underwater robotics program and competition",
          logoSrc: "img/logos/seaperch.png",
          bigLogoSrc: "img/logos/seaperch_big.png",
          applyNow: 0,
          about: {
            info:
              "SeaPerch is an innovative underwater robotics program that helps build the ROV from a kit comprised of low-cost, easily accessible parts, following a curriculum that teaches basic engineering and science concepts with a marine engineering theme. The SeaPerch Program provides students with the opportunity to learn about robotics, engineering, science, and mathematics (STEM) while building an underwater ROV as part of a science and engineering technology curriculum. Throughout the project, students will learn engineering concepts, problem-solving, teamwork, and technical applications.",
            age: [
              "Middle school students (Age: 8-12)",
              "high school students (Age: 13-18)"
            ],
            phases: ["Regional (Egypt)", "International (Maryland Uni, USA)"],
            dates: ["March", "May"],
            organisationLink: "https://www.seaperch.org",
            hasVideo: 1,
            videoLink: "https://www.youtube.com/embed/QKB-307YKr4?autoplay=0"
          },
          courses: [
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/seaperch.jpg" +
                this.part2(),
              name: "Seaperch Introduction",
              content: [
                "What is Seaperch ROV competition.",
                "Why should we participate in Seaperch.",
                "How we will work for the competition."
              ],
              duration: "1 session",
              id: "course1",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/power.jpg" +
                this.part2(),
              name: "Power/Electricity and ROV ",
              content: [
                "Basic electrical knowledge",
                "ROV Power System",
                "Intro to PCB",
                "Testing using AVO-meter"
              ],
              duration: "3 Sessions",
              id: "course2",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/auv_mech_design.jpg" +
                this.part2(),
              name: "Mechanics and ROV",
              content: [
                "ROV Mechanical Systems",
                "How to design",
                "Forces affecting the ROV",
                "ROV Stability"
              ],
              duration: "3 Sessions",
              id: "course3",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/assembly.jpg" +
                this.part2(),
              name: "Kit Assembly",
              content: [
                "Getting familiar with Vortex Educational Kit parts.",
                "Assembly of mechanical part together.",
                "Assembly of electrical part together.",
                "Testing Kit underwater."
              ],
              duration: "2 Sessions",
              id: "course4",
              fade: "js--fadeInRight"
            }
          ],
          hasLearningTrack: 1
        },
        {
          id: 3,
          name: "MATE",
          fullName: "Marine Advanced Technology Education",
          logoSrc: "img/logos/mate.png",
          bigLogoSrc: "img/logos/mate_big.png",
          applyNow: 0,
          about: {
            info:
              "The MATE ROV Competition uses remotely operated vehicles to inspire and challenge students to learn and creatively apply science, technology, engineering, and math (STEM) to solve real-world problems and strengthen their critical thinking, collaboration, entrepreneurship, and innovation.",
            age: [
              "University Students (Explorers)",
              "Middle/High Schools (Rangers)",
              "Elem./middle Schools (Scouts)"
            ],
            phases: [
              "Local (Egypt)",
              "Regional (Egypt)",
              "International (USA)"
            ],
            dates: ["February", "April", "June"],
            organisationLink: "https://www.materovcompetition.org",
            hasVideo: 0,
            videoLink:
              "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fvortexroboticsegypt%2Fvideos%2F431880244268469%2F&show_text=0&width=560"
          },
          courses: [
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/solidworks.jpg" +
                this.part2(),
              name: "Solidworks",
              content: [
                "SolidWorks Interface",
                "2D Sketching",
                "3D Features",
                "Advanced features",
                "Assemblies",
                "Introduction to simulation"
              ],
              duration: "20 Hours",
              id: "course1",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/sealing.jpg" +
                this.part2(),
              name: "Sealing Techniques",
              content: [
                "Sealing basics",
                "Codes and Standards",
                "Static Sealing VS Dynamic Sealing",
                "Advanced Sealing Techniques",
                "Safety and Testing"
              ],
              duration: "10 Hours",
              id: "course2",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/pneumatic.jpg" +
                this.part2(),
              name: "Basics of Pneumatics",
              content: [
                "Safety",
                "Pneumatic VS Hydraulic",
                "Components and Circuits",
                "Applications in sealing and buoyancy",
                "FluidSim"
              ],
              duration: "12 Hours",
              id: "course3",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/power.jpg" +
                this.part2(),
              name: "Electric Power",
              content: [
                "Power basics and concepts",
                "Power calculations and Tether selection",
                "transistors and switches",
                "Motors and Motor drivers"
              ],
              duration: "8 Hours",
              id: "course4",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/pcb.jpg" +
                this.part2(),
              name: "PCB",
              content: [
                "Designing electric circuits",
                "PCB Designing with Eagle",
                "Single Layer fabrication",
                "Double Layer PCB fabricarion"
              ],
              duration: "12 Hours",
              id: "course5",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/programming.jpg" +
                this.part2(),
              name: "Programming Concepts",
              content: [
                "Introduction to Programming (C-Language)",
                "Memory and Variables",
                "Conditional and Looping Statements",
                "Arrays and Pointers",
                "Functions"
              ],
              duration: "8 Hours",
              id: "course6",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/control.jpg" +
                this.part2(),
              name: " ",
              content: [
                "Control Systems",
                "Introduction to MicroControllers",
                "Arduino",
                "Many Projects All-Over the course"
              ],
              subContent: [
                "Idea",
                "Syntax",
                "Digital I/O",
                "Analog I/O",
                "Dealing with some sensors",
                "Serial Monitor"
              ],
              duration: "16 Hours",
              id: "course7",
              fade: "js--fadeInLeft"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/communication.jpg" +
                this.part2(),
              name: "Communication",
              content: [
                "Communication Methods",
                "Protocols Characteristics",
                "different Protocols and their applications"
              ],
              duration: "4 Hours",
              id: "course8",
              fade: "js--fadeInRight"
            },
            {
              img:
                "background : " +
                this.part1() +
                "img/courses/advanced.jpg" +
                this.part2(),
              name: "Advanced Content",
              content: [
                "Manufacturing Methods",
                "Steps of Design",
                "Propulsion",
                "Vision System",
                "Image Processing"
              ],
              duration: "16 Hours",
              id: "course9",
              fade: "js--fadeInLeft"
            }
          ],
          hasLearningTrack: 1
        },
        {
          id: 4,
          name: "UMVC",
          fullName: "Unmanned Maritime Vehicle Competition",
          logoSrc: "img/logos/umvc.png",
          bigLogoSrc: "img/logos/umvc_big.png",
          applyNow: 0,
          about: {
            info:
              "Unmanned Maritime Vehicle Challenge is an International Competition sponsored by the Egyptian Armed Forces and organized by the Military Technical College and the Unmanned Integrated Systems Technology and Innovation Center",
            age: ["Undergraduates Students (Age: 19-23)"],
            phases: ["Finals in MTC, Egypt"],
            dates: ["August"],
            organisationLink: " https://umvc.conferences.ekb.eg",
            hasVideo: 0,
            videoLink:
              "https://www.facebook.com/watch/?v=431880244268469&extid=urE3DtBSnlPktSz2"
          },
          courses: [],
          hasLearningTrack: 0
        }
      ],

      rovs1: [
        {
          name: "Sturgeon",
          src: "img/rovs/sturgeon.jpg"
        },
        {
          name: "Kraken",
          src: "img/rovs/kraken.jpg"
        },
        {
          name: "V-Ray",
          src: "img/rovs/vray.jpg"
        },
        {
          name: "Red Piranha",
          src: "img/rovs/redpiranha.jpg"
        }
      ],
      rovs2: [
        {
          name: "Lady Bug",
          src: "img/rovs/ladybug.jpg"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#table_img {
  transform: rotate(180deg);
}
$secondary: #337be6;
$primary: #337be6;
$dark-primary: #176ae6;
$light-primary: #c5cae9;
$text: #ffffff;
$primary-text: #212121;
$secondary-text: #757575;
$accent: #00264a;

section {
  padding: 30px 0;
}

.academy-container {
  scroll-behavior: smooth;
}

html,
body {
  overflow-x: hidden;
  scroll-behavior: smooth;
}

body {
  font-family: "Roboto";
  font-size: 17px;
  font-weight: 400;
  background-color: #eee;
}

h1 {
  font-size: 200%;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-weight: 400;
}

.mb-0 {
  color: #00264a;
  font-weight: bold;
}

.section-pic {
  transition: transform 0.5s;
}

.va-logo {
  // animation: 2s fadeIn;
  // animation-fill-mode: forwards;
  // visibility: hidden;
  width: 100%;
  overflow: hidden;
}

.section_header {
  background-color: #f2f2f2;
  width: 100%;
  text-align: center;
  padding-top: 60px;
  padding-bottom: 40px;
}

.section-label {
  margin: auto;
  font-size: 200%;
  padding-top: 20px;
  color: #00264a;
  font-weight: 400;
}

.close {
  font-size: 2.5rem;
}

.fadingEffect {
  position: absolute;
  top: 50px;
  bottom: 0;
  right: 0;
  width: 0%;
  height: 340px;
  background: #f2f2f2;
  -moz-animation: showHide 3s ease-out; /* Firefox */
  -webkit-animation: showHide 3s ease-out; /* Safari and Chrome */
  -ms-animation: showHide 3s ease-out; /* IE10 */
  -o-animation: showHide 3s ease-out; /* Opera */
  animation: showHide 3s ease-out;
}

.team-card {
  overflow: hidden;
  border: 20px solid gray;
  box-shadow: 0 20px 25px -15px rgba(0, 0, 0, 0.3);
  .card-img-top:hover {
    width: 105%;
    margin: auto;
    cursor: pointer;
  }
}

.rov-image {
  -webkit-transition: width 0.5s; /* For Safari 3.1 to 6.0 */
  transition: width 0.5s;
  margin-bottom: 50px !important;
}

.rov-image:hover {
  width: 80%;
  margin: auto;
  cursor: pointer;
}

.card-img-top {
  -webkit-transition: width 0.5s; /* For Safari 3.1 to 6.0 */
  transition: width 0.5s;
}

@-webkit-keyframes showHide {
  /* Chrome, Safari */
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@-moz-keyframes showHide {
  /* FF */
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@-ms-keyframes showHide {
  /* IE10 */
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@-o-keyframes showHide {
  /* Opera */
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@keyframes showHide {
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    visibility: visible;
    opacity: 1;
  }
}

.va-img {
  width: 43%;
  margin-bottom: 70px;
}

.section-pic:hover {
  transform: scale(1.3);
}

.section-pic-container {
  transition: width 0.5s;
  transition: transform 0.5s;
}

.section-pic-container:hover {
  width: 26%;
}

.section-img {
  height: 300px;
  width: 100%;
}

.region-header {
  font-size: 2.2vw;
  color: #072847;
  margin: auto;
}

.tips {
  color: darkgrey;
  width: 50%;
  display: inline-block;
}
header {
  background: $primary;
  color: $text;
  padding: 150px 0;

  p {
    font-family: "Allura";
    color: rgba(255, 255, 255, 0.2);
    margin-bottom: 0;
    font-size: 60px;
    margin-top: -30px;
  }
}
.vep_content {
  text-align: justify;
}
.timeline {
  position: relative;

  &::before {
    content: "";
    background: $light-primary;
    width: 5px;
    height: 95%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}

.timeline-item {
  width: 100%;
  margin-bottom: 70px;

  &:nth-child(even) {
    .timeline-content {
      float: right;
      padding: 40px 30px 10px 30px;

      .date {
        right: auto;
        left: 0;
      }

      &::after {
        content: "";
        position: absolute;
        border-style: solid;
        width: 0;
        height: 0;
        top: 30px;
        left: -15px;
        border-width: 10px 15px 10px 0;
        border-color: transparent #f5f5f5 transparent transparent;
      }
    }
  }

  &::after {
    content: "";
    display: block;
    clear: both;
  }
}

.timeline-content {
  position: relative;
  width: 45%;
  padding: 10px 30px;
  border-radius: 4px;
  background: #f5f5f5;
  box-shadow: 0 20px 25px -15px rgba(0, 0, 0, 0.3);

  &::after {
    content: "";
    position: absolute;
    border-style: solid;
    width: 0;
    height: 0;
    top: 30px;
    right: -15px;
    border-width: 10px 0 10px 15px;
    border-color: transparent transparent transparent #f5f5f5;
  }
}

.timeline-img {
  width: 30px;
  height: 30px;
  background: $secondary;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  margin-top: 25px;
  margin-left: -15px;
}
.timeline-end-img {
  width: 50px;
  height: 50px;
  background: $primary;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  margin-top: -110px;
  margin-left: -25px;
}

.timeline a {
  background: $primary;
  color: $text;
  padding: 8px 20px;
  text-transform: uppercase;
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 10px;
  display: inline-block;
  border-radius: 2px;
  box-shadow: 0 1px 3px -1px rgba(0, 0, 0, 0.6);

  &:hover,
  &:active,
  &:focus {
    background: darken($primary, 10%);
    color: $text;
    text-decoration: none;
  }
}

.timeline-card {
  padding: 0 !important;

  p {
    padding: 0 20px;
  }

  a {
    margin-left: 20px;
  }
}

.timeline-item {
  .timeline-img-header {
    /*background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('../../public/img/courses/pneumatic.png')  center center no-repeat;*/
    background-size: cover !important;
  }
}

.timeline-img-header {
  width: 100%;
  height: 200px;
  position: relative;
  margin-bottom: 20px;

  h2 {
    text-shadow: 2px 2px #00264a;
    /*color: $text;*/
    color: #f5f5f5;
    position: absolute;
    bottom: 5px;
    left: 20px;
  }
}

blockquote {
  margin-top: 30px;
  color: $secondary-text;
  border-left-color: $primary;
  padding: 0 20px;
}

.card-img-bottom {
  width: 70%;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
  margin: auto;
}

.date {
  background: $accent;
  display: inline-block;
  color: $text;
  padding: 10px;
  position: absolute;
  top: 0;
  right: 0;
}
#rov_card {
  width: 80% !important;
  min-width: 220px;
  left: 50%;
  position: relative;
  transform: translate(-50%, 0%);
}

.learning-track-name {
  width: 80%;
  margin: auto;
  color: #072847;
  text-align: center;
}

.btn-outline-primary {
  color: #072847;
  border-color: #072847;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #072847;
  border-color: #072847;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #072847;
  background-color: #f2f2f2;
  border-color: #072847;
}

.image-zoom-container {
  list-style: none;

  margin-top: -100px;
}
.zoom-container {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 18%;
  font-size: 16px;
  font-size: 1rem;
  cursor: pointer;
  border: 10px solid rgba(0, 0, 0, 0);
  vertical-align: top;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.zoom-container img {
  border-radius: 10%;
  display: block;
  width: 100%;
  height: auto;
  -webkit-transition: all 0.5s ease; /* Safari and Chrome */
  -moz-transition: all 0.5s ease; /* Firefox */
  -ms-transition: all 0.5s ease; /* IE 9 */
  -o-transition: all 0.5s ease; /* Opera */
  transition: all 0.5s ease;
  -webkit-transform: scale(0.8); /* Safari and Chrome */
  -moz-transform: scale(0.8); /* Firefox */
  -ms-transform: scale(0.8); /* IE 9 */
  -o-transform: scale(0.8); /* Opera */
  transform: scale(0.8);
}
.zoom-container .zoom-caption {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  //background: rgba(0, 0, 0, .4);
  background: rgba(0, 0, 0, 0);
  -webkit-transition: all 0.5s ease; /* Safari and Chrome */
  -moz-transition: all 0.5s ease; /* Firefox */
  -ms-transition: all 0.5s ease; /* IE 9 */
  -o-transition: all 0.5s ease; /* Opera */
  transition: all 0.5s ease;
}
.zoom-container .zoom-caption h3 {
  display: block;
  text-align: center;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 1.5em;
  font-weight: 900;
  letter-spacing: -1px;
  text-transform: uppercase;
  color: #072847;
  margin: 67% 0 0;
  padding: 10px 0;
  //border-top: 5px solid rgba(255, 255, 255, .15);
  //border-bottom: 5px solid rgba(255, 255, 255, .15);
  border-top: 5px solid rgba(4, 40, 71, 0.15);
  border-bottom: 5px solid rgba(4, 40, 71, 0.15);
}
.zoom-container:hover img {
  -webkit-transform: scale(1); /* Safari and Chrome */
  -moz-transform: scale(1); /* Firefox */
  -ms-transform: scale(1); /* IE 9 */
  -o-transform: scale(1); /* Opera */
  transform: scale(1);
}
.zoom-container:hover .zoom-caption {
  background: none;
}

.apply-btn {
  width: 100%;
}

.competition-content {
  width: 80%;
  margin: auto;
  padding: 3%;
  -webkit-box-shadow: 4px 3px 27px 0px rgba(0, 0, 0, 0.82);
  -moz-box-shadow: 4px 3px 27px 0px rgba(0, 0, 0, 0.82);
  box-shadow: 4px 3px 27px 0px rgba(0, 0, 0, 0.82);
  border-radius: 15px;
  background-color: #f2f2f2;
}

.container-iframe {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.list-header .card-header {
  background-color: #072847;
  color: white;
  font-weight: 400;
}

.learning-track-button {
  font-size: 130%;
}

.notes {
  color: darkgray;
}

.competition-name {
  font-size: 800%;
}

.competition-big-logo-container {
  width: 100%;
  height: auto;
}

.competition-big-logo {
  width: 40%;
  height: auto;
  margin: auto;
}

@media (max-width: 480px) {
  .zoom-container {
    width: 50%;
  }

  .va-img {
    width: 80%;
  }

  .fadingEffect {
    height: 250px;
  }
}

@media screen and (max-width: 768px) {
  .competitions-row .col {
    flex-basis: auto !important;
  }

  .competitions-row .btn {
    width: 100% !important;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .zoom-container {
    width: 50%;
  }

  .region-header {
    font-size: 4.5vw;
    padding: 20px;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }

  .competition-big-logo-container {
    display: none;
  }

  h2 {
    font-size: 1.5rem;
  }
  .competition-content {
    padding: 0%;
  }
  .timeline {
    &::before {
      left: 50px;
    }

    .timeline-img {
      left: 50px;
    }
    .timeline-end-img {
      left: 50px;
    }
    .timeline-content {
      max-width: 100%;
      width: auto;
      margin-left: 70px;
    }

    .timeline-item {
      &:nth-child(even) {
        .timeline-content {
          float: none;
        }
      }

      &:nth-child(odd) {
        .timeline-content {
          &::after {
            content: "";
            position: absolute;
            border-style: solid;
            width: 0;
            height: 0;
            top: 30px;
            left: -15px;
            border-width: 10px 15px 10px 0;
            border-color: transparent #f5f5f5 transparent transparent;
          }
        }
      }
    }
  }
}
</style>
